// extracted by mini-css-extract-plugin
export default {"container":"ExtProjectLinks-module__container___LKSMA","removeButton":"ExtProjectLinks-module__removeButton___BvsHX"};